import {
  Button,
  Descriptions,
  Drawer,
  Form,
  message,
  Modal,
  PageHeader,
  Select,
  Table,
  Switch,
  Row,
  Col,
} from "antd";
import React from "react";
import { professionalAction, userActions } from "../../_actions";
import { connect } from "react-redux";
const { Option } = Select;
class AllocationGunaMege extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      merge: false,
      officerUsers: [],
      mergeData: [],
      isConfirmationModalVisible: false,
      selectedRecord: null,
      selectCityId: undefined,
      selectedCityId: null,
      states: [],
      selected_state: undefined,
      stateCities: [],
      selectedOfficer: [],
    };
  }

  getCitySummary = () => {
    const summary = {};
    (this.state.mergeData || []).forEach((item) => {
      const city = item.City || "-";
      const key = item.cityId || city;
      if (!summary[key]) {
        summary[key] = {
          key,
          cityId: item.cityId,
          City: city,
          count: 0,
        };
      }
      summary[key].count += 1;
    });
    return Object.values(summary).map((item, index) => ({
      ...item,
      index: index + 1,
    }));
  };
  handleMerge = () => {
    const selectedOfficers = Array.isArray(this.state.selectedOfficer)
      ? this.state.selectedOfficer
      : [];
    if (!this.state.selectCityId || !selectedOfficers.length) {
      message.error("Please select City and Username");
      return;
    }
    userActions
      .mergeOfficerUsers({
        is_merge: true,
        userIds: selectedOfficers,
      })
      .then(() => {
        message.success("Add Merge successful");
        this.setState({
          merge: false,
          selectedOfficer: [],
          selectCityId: undefined,
          selected_state: undefined,
          officerUsers: [],
        });
        this.mergeOfficeUserList();
      })
      .catch(() => {
        message.error("Failed to update merge status");
      });
  };

  handleConfirmToggle = () => {
    const { selectedRecord } = this.state;
    if (!selectedRecord) {
      return;
    }
    const data = {
      is_merge: !selectedRecord.is_merge,
    };
    userActions
      .mergeOfficerUsers(data, selectedRecord.id)
      .then((res) => {
        message.success("Merge status updated successfully");
        this.setState({
          isConfirmationModalVisible: false,
          selectedRecord: null,
        });
        this.mergeOfficeUserList();
      })
      .catch((error) => {
        message.error("Failed to update merge status");
        console.error("Error updating merge status:", error);
      });
  };

  handleToggleSwitch = (record) => {
    this.setState({ isConfirmationModalVisible: true, selectedRecord: record });
  };

  handleCancelToggle = () => {
    this.setState({ isConfirmationModalVisible: false, selectedRecord: null });
  };

  async allOfficerUsers(cityId) {
    // const response = await userActions.allOfficerUsers();

    // this.setState({ officerUsers: response.data });
    const response = await userActions.findCityWiseUsers(cityId);
    this.setState({ officerUsers: response.user });
  }

  async mergeOfficeUserList() {
    const response = await userActions.mergeOfficeUserList();
    let data = response.data;
    data.forEach((item, index) => {
      item.index = index + 1;
    });
    this.setState({ mergeData: response.data });
  }
  getCountry = () => {
    professionalAction.getCountry().then((res) => {
      this.setState({
        states: res.pc_countrystates || [],
      });
    });
  };

  getStatesWiseCityData = (id) => {
    professionalAction.getStatesWiseCityData(id).then((res) => {
      this.setState({
        stateCities: res.pc_citiesData || [],
      });
    });
  };

  componentDidMount() {
    this.mergeOfficeUserList();
    this.getCountry();
  }

  handleStateChange = (value) => {
    this.setState(
      {
        selected_state: value,
        selectCityId: undefined,
        stateCities: [],
        officerUsers: [],
        selectedOfficer: [],
      },
      () => {
        if (value) {
          this.getStatesWiseCityData(value);
        }
      },
    );
  };

  handleChange = (e) => {
    this.setState({
      selectCityId: e,
      selectedOfficer: [],
      officerUsers: [],
    });
    if (e) {
      this.allOfficerUsers(e);
    }
  };
  render() {
    const detailColumns = [
      {
        title: "Sr.No",
        dataIndex: "index",
        key: "index",
      },
      {
        title: "City",
        dataIndex: "City",
        key: "City",
      },
      {
        title: "Name",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "Police Station",
        dataIndex: "districtName",
        key: "districtName",
      },
      {
        title: "Action",
        key: "action",
        render: (text, record) => (
          <Switch
            checked={record.is_merge}
            onChange={() => this.handleToggleSwitch(record)}
          />
        ),
      },
    ];
    const summaryColumns = [
      {
        title: "Sr.No",
        dataIndex: "index",
        key: "index",
      },
      {
        title: "City",
        dataIndex: "City",
        key: "City",
      },
      {
        title: "Count",
        dataIndex: "count",
        key: "count",
        render: (count, record) => (
          <Button
            type="primary"
            shape="circle"
            onClick={() => this.setState({ selectedCityId: record.cityId })}
          >
            {count}
          </Button>
        ),
      },
    ];
    const citySummary = this.getCitySummary();
    const totalCount = citySummary.reduce((sum, item) => sum + item.count, 0);
    const selectedCity = citySummary.find(
      (item) => item.cityId === this.state.selectedCityId,
    );
    const detailData =
      this.state.selectedCityId != null
        ? this.state.mergeData
            .filter((item) => item.cityId === this.state.selectedCityId)
            .map((item, index) => ({ ...item, index: index + 1 }))
        : [];
    return (
      <>
        <PageHeader className="site-page-header" ghost={false} onBack={false}>
          <Descriptions size="small" column={1}>
            <Descriptions.Item>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: "16px",
                  width: "100%",
                }}
              >
                <Button
                  type="primary"
                  onClick={() => this.setState({ merge: true })}
                >
                  Merge
                </Button>
                <span
                  style={{
                    padding: "4px 12px",
                    background: "#f0f5ff",
                    border: "1px solid #adc6ff",
                    borderRadius: 8,
                    fontSize: 13,
                    fontWeight: 600,
                    color: "#1677ff",
                  }}
                >
                  Total: {totalCount}
                </span>
              </div>
            </Descriptions.Item>
          </Descriptions>
          <Table
            columns={summaryColumns}
            dataSource={citySummary}
            rowKey="key"
          />
        </PageHeader>
        <Drawer
          title={
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                paddingRight: 24,
              }}
            >
              <span>{selectedCity?.City || "Merge"}</span>
              <span
                style={{
                  padding: "2px 12px",
                  background: "#f0f5ff",
                  border: "1px solid #adc6ff",
                  borderRadius: 8,
                  fontSize: 13,
                  fontWeight: 600,
                  color: "#1677ff",
                }}
              >
                Total: {detailData.length}
              </span>
            </div>
          }
          placement="right"
          width="80%"
          visible={this.state.selectedCityId != null}
          onClose={() => this.setState({ selectedCityId: null })}
        >
          <Table
            columns={detailColumns}
            dataSource={detailData}
            rowKey="id"
          />
        </Drawer>
        {this.state.merge && (
          <Modal
            title="Merge"
            open={this.state.merge}
            onCancel={() => this.setState({ merge: false })}
            footer={null}
            width={95 + "%"}
            centered
          >
            <div
              id="view-profile-merge"
              style={{ backgroundColor: "transparent" }}
            >
              <Form>
                <Row style={{ marginTop: "10px" }} gutter={[16, 16]}>
                  <Col xs={24} sm={6} md={6}>
                    <Form.Item label="State" name="state">
                      <Select
                        value={this.state.selected_state}
                        onChange={this.handleStateChange}
                        placeholder="Select State"
                        style={{ width: "100%" }}
                        showSearch
                        allowClear
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option?.children
                            ?.toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        getPopupContainer={(triggerNode) =>
                          triggerNode.parentNode
                        }
                      >
                        {this.state.states.map((item) => (
                          <Option key={item.id} value={item.id}>
                            {item.state}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  {this.state.selected_state && (
                    <Col xs={24} sm={6} md={6}>
                      <Form.Item label="City" name="city">
                        <Select
                          value={this.state.selectCityId}
                          onChange={(val) => this.handleChange(val)}
                          placeholder="Select City"
                          style={{ width: "100%" }}
                          showSearch
                          allowClear
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option?.children
                              ?.toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          getPopupContainer={(triggerNode) =>
                            triggerNode.parentNode
                          }
                        >
                          {this.state.stateCities.map((item) => (
                            <Option key={item.id} value={item.id}>
                              {item.City}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  )}
                  <Col xs={24} sm={12} md={12}>
                    <Form.Item
                      label="Name"
                      name="selectedOfficer"
                      rules={[
                        { required: true, message: "Please select an officer" },
                      ]}
                    >
                      <Select
                        mode="multiple"
                        filterOption={(input, option) =>
                          option?.children
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        optionFilterProp="children"
                        style={{ width: "100%" }}
                        value={this.state.selectedOfficer}
                        allowClear
                        showSearch
                        maxTagCount={2}
                        placeholder="Select Name"
                        onChange={(val) =>
                          this.setState({ selectedOfficer: val })
                        }
                        getPopupContainer={(triggerNode) =>
                          triggerNode.parentNode
                        }
                      >
                        {this.state.officerUsers &&
                          this.state.officerUsers.length > 0 &&
                          this.state.officerUsers
                            .filter(
                              (officer) =>
                                !this.state.mergeData?.some(
                                  (merged) => merged.id === officer.id
                                )
                            )
                            .map((res) => (
                              <Option key={res.id} value={res.id}>
                                {res.name}({res?.districtName})
                              </Option>
                            ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
                <Form.Item>
                  <Button
                    type="primary"
                    onClick={this.handleMerge}
                    style={{ float: "right" }}
                  >
                    Merge
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </Modal>
        )}
        {this.state.isConfirmationModalVisible && this.state.selectedRecord && (
          <Modal
            title="Confirm Merge"
            open={this.state.isConfirmationModalVisible}
            onCancel={() =>
              this.setState({
                isConfirmationModalVisible: false,
                selectedRecord: null,
              })
            }
            onOk={this.handleConfirmToggle}
            okText="Yes"
            cancelText="No"
            centered
          >
            <p>
              Are you sure you want to{" "}
              {this.state.selectedRecord.is_merge ? "disable" : "enable"} merge
              for {this.state.selectedRecord.name}?
            </p>
          </Modal>
        )}
      </>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  return {
    user,
    users,
    professionals,
  };
}
const connectedAllocationGunaMege =
  connect(mapStateToProps)(AllocationGunaMege);
export { connectedAllocationGunaMege as AllocationGunaMege };
